import { gql } from '@apollo/client';
import appraiserAdminFieldsFragment from './appraiserAdminFieldsFragment';

const EDIT_APPRAISER = gql`
  mutation EditAppraiser($externalUserId: Int!, $appraiser: AppraiserInput!) {
    editAppraiser(externalUserId: $externalUserId, appraiser: $appraiser) {
      ...AppraiserAdminFields
    }
  }
  ${appraiserAdminFieldsFragment}
`;

export default EDIT_APPRAISER;
